module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Note"
  }, [_c('header', [_c('a', {
    staticClass: "backToList"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _c('span', {
    staticClass: "menuText"
  }, [_vm._v("Viewing Note")])]), _c('a', {
    on: {
      "click": function($event) {
        _vm.editNote()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _c('a', {
    on: {
      "click": function($event) {
        _vm.deleteNote()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.note.title))]), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.parseTimeCreate(_vm.note.meta)))]), _c('div', {
    staticClass: "tag"
  }, [_vm._v(" " + _vm._s(_vm.note.tag))]), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.note.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bb03f04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Note.vue
// module id = 225
// module chunks = 1